goog.provide('el8.appchart.dialog.documentVitals');

goog.require('el8.appchart.visitNote.vitalFields');
goog.require('el8.appshared.form.buttons');
goog.require('el8.ptdata.vitalsCollections');
goog.require('el8.service.infoField');
goog.require('el8.template.appchart.dialog.documentVitals');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');


/**
 * Used to view or create standalone VitalsCollection documents
 *
 * Unlike most of our dialogs, there can be many instances of this dialog open,
 * so users can view old VCs which documenting new ones.
 */
el8.appchart.dialog.documentVitals = (function() {

    var module = {};

    var fields = [{
        name: 'collectedDate',
        selector: ':input[name="collectedDate"]',
        infoText: 'collection date..',
        datePickerOpts: {},
        defaultVal: function() { return el8.service.tz.today().asString(); },
        validate: {
            required: true,
            validDate: true,
            todayOrBefore: true
        }
    }];
    fields = fields.concat(el8.appchart.visitNote.vitalFields.getAll(false));

    /**
     * Each call to show() will spawn a new dialog,
     * which will be destroyed when that dialog is hidden. */
    module.show = function(spec) {

        spec = spec || {};
        var vitalsProcessor = null;

        var that = new el8.uiwidget.FormDialog({
            title: 'Document Vitals',
            autoHeight: true,
            width: 400,
            contentFn: el8.template.appchart.dialog.documentVitals.content
        });

        var form = new el8.uiwidget.Form({
            fields: fields,
            validationOpts: el8.util.validate.standardOpts
        });
        that.setForm(form);

        var doSave = function(_form, addAnother) {
            if (!_form.isValid()) { return; }

            if (!el8.appchart.nonvisitNote.main.isOpen()) {
                el8.uiwidget.alert('Documented Vitals must be attached to a Non-Visit Note. Please open an unsigned note to finish saving.');
                return;
            }
            var noteId = el8.appchart.nonvisitNote.main.getOpenNoteId();

            var vc = extractVitals(that);
            vc.setNoteId(noteId);
            el8.ptdata.vitalsCollections.saveItem(vc, false, {
                successCb: function() {
                    el8.appchart.nonvisitNote.main.addNewVital(vc);
                    that.hide();
                    if (addAnother) { module.show(); }
                    $(document).trigger("el8_noteVitalUpdate");
                }
            });
        };
        el8.appshared.form.buttons.addNonDraftDialogButtons(form, doSave, that);

        var super_init = that._init;
        that._init = function() {
            super_init.call(that);
            vitalsProcessor = new el8.appchart.visitNote.vitalsProcessor({
                form: form,
                weightProcessedElt: $('.weight-processed-val', that.getContentElt()),
                heightProcessedElt: $('.height-processed-val', that.getContentElt()),
                bmiContainer: $('.bmi', that.getContentElt())
            });
            bindTriggers(that, vitalsProcessor);

            var noteId = el8.appchart.nonvisitNote.main.getOpenNoteId();
            if (!noteId) {
                UIM && UIM.logError('Somehow managed to open doc vitals without a nonvisit note open.');
                return;
            }
            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('nonvisitPreviousHeight', [noteId]),
                success: function(data) {
                    if (data) {
                        vitalsProcessor.setPreviousHeight(data['height']);
                        vitalsProcessor.processHeightInput(true);
                        vitalsProcessor.processWeightInput();
                    }
                }
            });
        };

        var super_hide = that.hide;
        that.hide = function() {
            super_hide.call(that);
            that.destroy();
            vitalsProcessor = null;
        };

        that.show();
        if (spec.vcId) {
            var vitalsCollection = el8.ptdata.vitalsCollections.getById(spec.vcId);
            populateVitals(that, vitalsCollection);
            that.setTitle('Vitals: ' + vitalsCollection.getCollectedDate().asString());
            makeFormUneditable(that);
        } else {
            form.getInputField('collectedDate').focusSelect(); // to make it easier to change the date
        }
    };


    function extractVitals(dialog) {
        var form = dialog.getForm();
        // This will extract everything except:
        //   - the BP rows, which are structured oddly because there can be several,
        //   - BMI, which is not a form field
        //   - oxygen , which has a different name in the visit note
        var vc = el8.ptdata.vitalsCollections.create(form.getMapped());
        vc.setOxygen(form.getVal('percent'));

        var bps = [];
        $('.bp-input', dialog.getContentElt()).each(function() {
            var index = $(this).attr('_bpIndex');
            var systolic = form.getVal('bpS_'+index);
            var diastolic = form.getVal('bpD_'+index);
            var note = form.getVal('bpNote_'+index);
            if (systolic || diastolic || note) {
                bps.push({
                    bp_s: systolic,
                    bp_d: diastolic,
                    bp_note: note
                });
            }
        });
        vc.setBps(bps);

        vc.setBmi($('.bmi', dialog.getContentElt()).text());

        return vc;
    }

    function populateVitals(dialog, vc) {
        var form = dialog.getForm();
        for (var i=0; i < vc.getBps().length; i++) {
            if (i > 0) { addBpRow(dialog); } // row 0 was already added
            var bpRow = vc.getBps()[i];
            form.setVal('bpS_'+i, bpRow.bp_s);
            form.setVal('bpD_'+i, bpRow.bp_d);
            form.setVal('bpNote_'+i, bpRow.bp_note);
        }

        if (vc.getCollectedDate()) { // should always be true
            form.setVal('collectedDate', vc.getCollectedDate().asString());
        }

        var mapped = vc.asMap();
        if (mapped.bmi) {
            $('.bmi', dialog.getContentElt()).text(mapped.bmi);
        }

        // delete fields we don't need to populate in the loop below
        delete mapped['id'];
        delete mapped['noteId'];
        delete mapped['bps'];
        delete mapped['bmi'];
        delete mapped['collectedDate'];
        for (var key in mapped) {
            if (mapped.hasOwnProperty(key) && mapped[key]) {
                var fieldSpecKey = key;
                if (key === 'oxygen') { fieldSpecKey = 'percent'; }
                el8.appchart.visitNote.vitalFields.populateField(form._getFieldSpec(fieldSpecKey), mapped[key], form);
            }
        }

    }

    // There is no counterpart makeFormEditable because there are many instances of this dialog and a particular instance
    // will either be editable or uneditable from the start (i.e., it will either be an existing VC or a new one)
    function makeFormUneditable(dialog) {
        var $content = dialog.getContentElt();
        var $bmi = $('.bmi', $content);
        if (!$bmi.text()) { $bmi.closest('.el8FieldSection').hide(); } // same CSS dependency as Form.hideField()

        var form = dialog.getForm();
        form.disable();
        form.getButtonSet().enable();
        $('.add-bp-trigger', $content).hide();
        $('.remove-bp-trigger', $content).hide();
        $content.off('click', '.vitals-note-show-trigger');

        form.hideButton('save');
        form.hideButton('save-and-another');
        form.updateButtonCaption('cancel', 'Close');
        dialog.adjustHeight();
    }

    function bindTriggers(dialog, vitalsProcessor) {
        var $content = dialog.getContentElt();
        $content.on('click', '.vitals-note-show-trigger',  function() {
            var $this = $(this);
            var type = $this.attr('data-type');
            $('.'+type+'-note-section', $content).show()
                .find(':input').first().focusSelect();
            $this.closest('.vitals-wrapper').remove();
        });

        // Manage the BP rows
        $content.on('click', '.add-bp-trigger',  function() {
            addBpRow(dialog);
        });
        $content.on('click', '.remove-bp-trigger',  function() {
            $(this).closest('.bp-input').remove();

            el8.appchart.visitNote.vitalFields.cleanBpTriggers($content);
            dialog.adjustHeight();
        });

        // for each of these fields that handles unit conversions or does some validation, 
        // bind a change event
        ['height', 'weight', 'hc', 'pain'].forEach(function(name) {
            $content.on('change', ':input[name="'+name+'"]', function() {
                var changeFn = el8.appchart.visitNote.vitalFields.getChangeFn(name, vitalsProcessor);
                dialog.getForm().setVal(name, changeFn(), true); // don't trigger another change event
            });
        });
    }

    function addBpRow(dialog) {
        var $content = dialog.getContentElt();
        var index = $content.find('.bp-input').last().attr('_bpIndex')*1;
        index += 1; // find the last index used and then go up by one

        $('.bp-section', $content).append(
            el8.template.appchart.visitNote.bpInput({ 'index': index })
        );
        var newFields = el8.appchart.visitNote.vitalFields.getBpFields(index);
        newFields.forEach(function(f) { dialog.getForm().addField(f); });

        el8.appchart.visitNote.vitalFields.cleanBpTriggers($content);
        dialog.adjustHeight();
    }

    return module;

})();
